import { LoadingButton } from '@mui/lab';
import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import { SnackbarContext } from '../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { graphql } from 'gql';

const UpdateShow = graphql(`
    mutation UpdateShow_EditShowDialog($where: ShowWhere, $update: ShowUpdateInput) {
        updateShows(where: $where, update: $update) {
            shows {
                id
                title
            }
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
}

export default function EditShowDialog({ open, onClose }: Props) {
    const { selectedShow, setSelectedShow } = useContext(SeasonShowContext);
    const { success, error } = useContext(SnackbarContext);

    const [title, setTitle] = useState<string | undefined>(selectedShow?.title);

    useEffect(() => {
        if (open) {
            setTitle(selectedShow?.title);
        }
    }, [open, selectedShow])

    const [updateShow, { loading }] = useMutation(UpdateShow);

    const handleSave = async () => {
        try {
            await updateShow({
                variables: { where: { id: selectedShow!.id }, update: { title }},
            });

            setSelectedShow({ ...selectedShow!, title: title! });

            onClose();
            success('Show edited');
        } catch (e) {
            // @ts-ignore
            error('Failed to edit show. ' + e.message);
        }
    }

    const handleClose = () => {
        setTitle(selectedShow?.title);
        onClose();
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    }

    if (!selectedShow) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Edit Show</DialogTitle>
            <DialogContent>
                <TextField
                    sx={{ mt: 1, mb: 1 }}
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant='text'>Cancel</Button>
                <LoadingButton
                    onClick={handleSave}
                    disabled={!title}
                    variant='contained'
                    loading={loading}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}